import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { hasPermission } from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { adminLabels } from '../../../redux/constant/admin-label-constant';
import OpenModalButton from '../../ThemeComponents/openModelButton';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import { Link } from 'react-router-dom';
import ListForm from './ListForm';
import { listTypeActions } from '../../../redux/actions/list-type-actions';

var Modal = require('react-bootstrap-modal');

class ListType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModal: false,
            editModal: false,
            sorted: '',
            filtered: '',
            pageSize: 10,
            list_types: [],
            list_type: {},
        };

        this.callEditlistType = this.callEditlistType.bind(this);
        this.deleteListType = this.deleteListType.bind(this);
        this.deleteConfirmListType = this.deleteConfirmListType.bind(this);
        this.listTypesPaginationData = this.listTypesPaginationData.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
        this.handleListTypeSubmit = this.handleListTypeSubmit.bind(this);
    };

    handleListTypeSubmit(listData, formType) {
        this.setState({
            list_type: {
                title: listData.title,
                component_name: 'List Type'
            }
        }, () => {
            if (formType === 'add') {
                this.props.storeListTypeCall(this.state.list_type).then(
                    response => {
                        this.props.getAllListTypesCall(this.props.current_page, '', '', this.state.pageSize);
                        this.setState({
                            ...this.state,
                            addModal: false,
                        })
                    }
                )
            }
            else if (formType === 'edit') {
                this.props.editListTypeCall(this.state.list_type, listData.id).then(response => {
                    this.props.getAllListTypesCall(this.props.current_page, '', '', this.state.pageSize);
                    this.setState({
                        editModal: false
                    })
                });
            }
        });


    }

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        }, () => {
            this.refReactTable.fireFetchData()
        });

    }
    callEditlistType(id) {
        this.props.getListTypeItemCall(id).then(response => {
            this.setState({
                editModal: true
            });
        });
    }

    deleteListType(list_id) {
        this.props.deleteListTypeCall(list_id).then(response => {
            this.props.getAllListTypesCall(this.props.current_page, this.state.filtered, '', this.state.pageSize);
        });
    }
    //
    deleteConfirmListType = (list_id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName={this.props.name || 'list type'} onClosePro={onClose} deleteType={() => this.deleteListType(list_id)} />
                )
            }
        })
    }

    listTypesPaginationData(page, filter, sort, pageSize) {
        this.setState({ pageSize: pageSize }, function () {
            this.props.getAllListTypesCall(page, filter, sort, pageSize);
        });
    }

    render() {
        const { pages, loading } = this.props;
        const columns = [
            {
                Header: <div className='text-capitalize'>Manage Lists</div>,
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: <div className='text-capitalize'>All Lists</div>,
                        accessor: "title",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({ value, original }) => (
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('list-update') ? 'View List' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <span>
                                        {
                                            hasPermission('list-update') &&

                                            <Link className="viewIcon orderDetailsAction" to={{ pathname: `/Admin/manage-lists/${original.title}`, state: (original.parent_id ? { list_id: original.id, parent_id: original.parent_id } : { list_id: original.id }) }}>&nbsp;</Link>
                                        }
                                        {
                                            !hasPermission('list-update') &&
                                            <button type='button' className="viewIcon orderDetailsAction button_disabled" >&nbsp;</button>
                                        }
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('list-update') ? 'Edit List Type' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <span>
                                        {
                                            hasPermission('list-update') && original.editable == 1 &&
                                            <button type='button' className="editIcon orderDetailsAction " onClick={() => this.callEditlistType(value)}>&nbsp;</button>

                                        }
                                        {
                                            hasPermission('list-update') && original.editable == 0 &&
                                            <button type='button' className="editIcon orderDetailsAction button_disabled" >&nbsp;</button>
                                        }
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('list-delete') ? `Delete List Type` : adminLabels.DONT_ALLOW}</Popover>}>
                                    <span>
                                        {
                                            hasPermission('list-delete') && original.editable == 1 &&
                                            <button type='button' className="deleteIcon orderDetailsAction" onClick={() => this.deleteConfirmListType(value)}>&nbsp;</button>
                                        }
                                        {
                                            hasPermission('list-delete') && original.editable == 0 &&
                                            <button type='button' className="deleteIcon orderDetailsAction button_disabled" >&nbsp;</button>
                                        }
                                    </span>
                                </OverlayTrigger>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3 style={{ textAlign: 'center', fontWeight: "500" }}>Manage Lists</h3>
                                                </Col>

                                                <Col md={12}>
                                                    <div className="flexElem mt-xlg flexResponsive" style={{ "alignItems": "flex-start", "justifyContent": "space-between" }}>
                                                        <div className="block">
                                                            <OpenModalButton
                                                                openModal={hasPermission('list-create') ? HF.openModal.bind(this, "addModal") : null}
                                                                classButton={['customBtn btnBlue', !hasPermission('list-create') ? 'button_disabled' : '']}
                                                                buttonName={'Add List'}
                                                                tooltipText={hasPermission('list-create') ? 'Add List' : adminLabels.DONT_ALLOW}
                                                                classIcon={['']}
                                                            />
                                                        </div>

                                                        <div className="custom-search-input">
                                                            <FormInputs
                                                                ncols={["col-md-12"]}
                                                                onChange={this.filterSearchHandle}
                                                                proprieties={[
                                                                    {
                                                                        type: "text",
                                                                        bsClass: "form-control",
                                                                        placeholder: "Search List",
                                                                        onChange: this.filterSearchHandle,
                                                                        name: "filter"
                                                                    }
                                                                ]}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={12} className="mt-xlg">
                                                    <ReactTable
                                                        noDataText='No data found'
                                                        data={this.props.list_types_data}
                                                        pages={pages}
                                                        loading={loading}
                                                        columns={columns}
                                                        defaultPageSize={20}
                                                        className="-striped listing responsive"
                                                        pageData={this.listTypesPaginationData}
                                                        ref={(refReactTable) => {this.refReactTable = refReactTable;}}
                                                        manual
                                                        onFetchData={(state, instance) => {
                                                            var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                            state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>

                                        {/*Add Country Modal Start*/}
                                        {this.props.listData !== null &&
                                            <Modal show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader" backdrop={false} >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader' className="headerTitle">Add {this.props.name}</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-8 col-md-offset-2">
                                                            <ListForm
                                                                closeModel={HF.closeModal.bind(this, "addModal")}
                                                                formTypePro="add"
                                                                listPro={{ list: OC.list }}
                                                                handleListSubmit={this.handleListTypeSubmit}
                                                                name={this.props.title}
                                                                componentPro={'List'}
                                                                parentData={this.state.parent_data}
                                                                parent_id={this.props.parent_id}
                                                                listDataProp={this.state[this.props.title + '_data']}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        }

                                        {/*Add Country Modal End*/}

                                        {/*Edit Country Modal start*/}
                                        {this.props.listTypeItem &&
                                            <Modal show={this.state.editModal} onHide={HF.closeModal.bind(this, "editModal")} aria-labelledby="ModalHeader" backdrop={false} >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader' className="headerTitle">Edit Menu</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-8 col-md-offset-2">
                                                            <ListForm
                                                                closeModel={HF.closeModal.bind(this, "editModal")}
                                                                formTypePro="edit"
                                                                listPro={{ list: { ...this.props.listTypeItem } }}
                                                                handleListSubmit={this.handleListTypeSubmit}
                                                                name={this.props.title}
                                                                parentData={this.state.parent_data}
                                                                parent_id={this.props.parent_id}
                                                                listDataProp={this.state[this.props.title + '_data']}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        }
                                        {/*Edit Country Modal End*/}
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getAllListTypesCall: (page, filter, sort, pageSize) => { dispatch(listTypeActions.getAllListTypes(page, filter, sort, pageSize)) },
        getListTypeItemCall: (id) => { return dispatch(listTypeActions.getListTypeItem(id)) },
        storeListTypeCall: (listTypeData) => { return dispatch(listTypeActions.storeListTypeItem(listTypeData)) },
        editListTypeCall: (listTypeData, id) => { return dispatch(listTypeActions.editListType(listTypeData, id)) },
        deleteListTypeCall: (id) => { return dispatch(listTypeActions.deleteListType(id)) },

    });
};

function mapStateToProps(state, ownProps) {
    const { loading, pages, current_page, listTypeItem,
        list_types_data } = state.listTypeReducer;
    // const { listItempParent } = state.listReducer;
    return {
        loading, pages, current_page,
        list_types_data, listTypeItem,
        // listItempParent
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ListType);



// WEBPACK FOOTER //
// ./src/components/Admin/Lists/ListType.jsx